import * as React from "react";

export type BalloonsHandle = {
  launchAnimation: () => void;
};

export type BalloonsProps = {
  className?: string;
  onLaunch?: () => void;
};

const balloonIndexes = Array.from({ length: 18 }, (_, index) => index + 1);

function shouldReduceMotion() {
  return typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

const Balloons = React.forwardRef<BalloonsHandle, BalloonsProps>(({ className, onLaunch }, ref) => {
  const [burstId, setBurstId] = React.useState(0);
  const [isVisible, setIsVisible] = React.useState(false);
  const cleanupTimeoutRef = React.useRef<number | undefined>(undefined);

  const launchAnimation = React.useCallback(() => {
    if (typeof window === "undefined" || shouldReduceMotion()) {
      onLaunch?.();
      return;
    }

    window.clearTimeout(cleanupTimeoutRef.current);
    setIsVisible(false);

    window.requestAnimationFrame(() => {
      setBurstId((current) => current + 1);
      setIsVisible(true);
      cleanupTimeoutRef.current = window.setTimeout(() => setIsVisible(false), 4300);
      onLaunch?.();
    });
  }, [onLaunch]);

  React.useEffect(() => () => window.clearTimeout(cleanupTimeoutRef.current), []);

  React.useImperativeHandle(ref, () => ({ launchAnimation }), [launchAnimation]);

  return (
    <div className={["balloons-container", className].filter(Boolean).join(" ")} aria-hidden="true">
      {isVisible
        ? balloonIndexes.map((index) => (
            <span key={`${burstId}-${index}`} className={`balloon-particle balloon-particle-${index}`} />
          ))
        : null}
    </div>
  );
});

Balloons.displayName = "Balloons";

export { Balloons };
